import { memo, useCallback } from 'react';
import FJPhotoRemoveBgThumbnail from '../view/FJPhotoRemoveBgThumbnail';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import FJActionPhotoBgRemover from '../../../../redux/action/FJActionPhotoBgRemover';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJEvent from '../../../../store/FJEvent';
import { FJ_EVENT_TYPE } from '../../../../constants/FJEvenTypeConstant';

const FJPhotoRemoveBgThumbnailContainer = memo(function FJPhotoRemoveBgThumbnailContainer() {
    useLocalStore();
    const dispatch = useDispatch();

    const curMenuIndex = useSelector(state => state.photoBgRemover.curMenuIndex);
    const autoBgImageDataList = useSelector(state => state.photoBgRemover.autoBgImageDataList);
    const curSelectAutoBgImageIndex = useSelector(state => state.photoBgRemover.curSelectAutoBgImageIndex);
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);

    const handleClickItem = index => {
        dispatch(FJActionPhotoBgRemover.changeCurSelectAutoBgImage(index));
        FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
    };

    const handleAddThumbnail = useCallback(
        thumbnail => {
            dispatch(FJActionPhotoBgRemover.addThumbnailAction(thumbnail));
        },
        [dispatch],
    );

    const handleUpdateThumbnail = useCallback(
        thumbnail => {
            dispatch(FJActionPhotoBgRemover.updateThumbnailListAction(thumbnail));
        },
        [dispatch],
    );

    if (!autoBgImageDataList || autoBgImageDataList.length === 0) {
        return null;
    }

    const isShowThumbnail = curMenuIndex === 0 && autoBgImageDataList.length > 1 && headerTabIndex === 0;

    return (
        <FJPhotoRemoveBgThumbnail
            autoBgImageDataList={autoBgImageDataList}
            curSelectAutoBgImageIndex={curSelectAutoBgImageIndex}
            handleClickItem={handleClickItem}
            handleAddThumbnail={handleAddThumbnail}
            handleUpdateThumbnail={handleUpdateThumbnail}
            isShow={isShowThumbnail}
        />
    );
});

export default FJPhotoRemoveBgThumbnailContainer;
